import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],

});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async getAllP(cxt) {
        let data = await client.get('societe');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllPage(ctx, params = {}) {
        const { page = 0, size = 10, sort = '', type, after, before, code, email, contact, contactDeux, contactTrois, contactQuatre, email2, matricule, rccm, raisonSociale, sousLibelle, statutMaintien } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(type && { type }),
            ...(after && { after }),
            ...(before && { before }),
            ...(code && { code }),
            ...(email && { email }),
            ...(contact && { contact }),
            ...(contactDeux && { contactDeux }),
            ...(contactTrois && { contactTrois }),
            ...(contactQuatre && { contactQuatre }),
            ...(email2 && { email2 }),
            ...(matricule && { matricule }),
            ...(rccm && { rccm }),
            ...(raisonSociale && { raisonSociale }),
            ...(sousLibelle && { sousLibelle }),
            ...(statutMaintien && { statutMaintien }),
        }).toString();
        let { data } = await client.get(`societe?${queryParams}`);
        ctx.commit("SET_ALL", data);
        return data;
    },
    async getAll(cxt) {
        let data = await client.get('societe/all');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, id) {
        let data = await client.get('societe/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('societe/edit/' + payload.id, payload) : await client.post('societe/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('societe/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },

    async getAllDirigeant(cxt, id) {
        // Tous les dirigeants (actifs + inactifs) pour afficher la liste complète avec badge Actif/Inactif
        let data = await client.get('societe/' + id + '/dirigeants/all');
        return data;
    },
    async regenererDocument(cxt, societeId) {
        const { data } = await client.post(`societe/${societeId}/regenerer-document`);
        return data;
    },
    async getDossierDocuments(cxt, societeId) {
        const { data } = await client.get('societe/' + societeId + '/documents');
        return data;
    },
    async addFichierToSociete(cxt, { societeId, file }) {
        const formData = new FormData();
        formData.append('file', file);
        const { data } = await client.post('societe/' + societeId + '/fichiers', formData);
        return data;
    },
    async exportToPdf(ctx, params = {}) {
        const { type, after, before, code, email, contact, contactDeux, contactTrois, contactQuatre, email2, matricule, rccm, raisonSociale, sousLibelle, sousCategorieId, statutMaintien } = params;
        const queryParams = new URLSearchParams({
            ...(type && { type }),
            ...(after && { after }),
            ...(before && { before }),
            ...(code && { code }),
            ...(email && { email }),
            ...(contact && { contact }),
            ...(contactDeux && { contactDeux }),
            ...(contactTrois && { contactTrois }),
            ...(contactQuatre && { contactQuatre }),
            ...(email2 && { email2 }),
            ...(matricule && { matricule }),
            ...(rccm && { rccm }),
            ...(raisonSociale && { raisonSociale }),
            ...(sousLibelle && { sousLibelle }),
            ...(sousCategorieId != null && sousCategorieId !== '' && { sousCategorieId }),
            ...(statutMaintien && { statutMaintien }),
        }).toString();
        
        const response = await client.get(`societe/export/pdf?${queryParams}`, {
            responseType: 'blob'
        });
        return response;
    },
    async exportToExcel(ctx, params = {}) {
        const { type, after, before, code, email, contact, contactDeux, contactTrois, contactQuatre, email2, matricule, rccm, raisonSociale, sousLibelle, sousCategorieId, statutMaintien } = params;
        const queryParams = new URLSearchParams({
            ...(type && { type }),
            ...(after && { after }),
            ...(before && { before }),
            ...(code && { code }),
            ...(email && { email }),
            ...(contact && { contact }),
            ...(contactDeux && { contactDeux }),
            ...(contactTrois && { contactTrois }),
            ...(contactQuatre && { contactQuatre }),
            ...(email2 && { email2 }),
            ...(matricule && { matricule }),
            ...(rccm && { rccm }),
            ...(raisonSociale && { raisonSociale }),
            ...(sousLibelle && { sousLibelle }),
            ...(sousCategorieId != null && sousCategorieId !== '' && { sousCategorieId }),
            ...(statutMaintien && { statutMaintien }),
        }).toString();

        const response = await client.get(`societe/export/excel?${queryParams}`, {
            responseType: 'blob'
        });
        return response;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
